module.exports = __webpack_public_path__ + "static/form1-64d2e3d782054c43f32b70b51ef3cf5c.png";